import {
  getAssignableRoles,
  searchUsers,
  updateUserPartners,
  updateUserPassword,
  updateUserRoles,
} from '../../api/userManagement/userManagement';
import { ManagedUser, UserSearchRequest } from '../../api/userManagement/userManagementApiTypes';
import { UserRole } from '../../store/user/types';
import { getArrayIfNotEmpty, getValueIfNotEmpty } from '../../utils/filter';
import { UsersFilter } from './usersState';

function toUserSearchRequest(filter: UsersFilter): UserSearchRequest {
  return {
    username: getValueIfNotEmpty(filter.username),
    name: getValueIfNotEmpty(filter.name),
    partnerCodes: getArrayIfNotEmpty(filter.partnerCodes),
    roles: getArrayIfNotEmpty(filter.roles),
  };
}

export async function fetchUsers(
  filter: UsersFilter,
  signal?: AbortSignal,
): Promise<ManagedUser[]> {
  return searchUsers(toUserSearchRequest(filter), signal);
}

export async function fetchAssignableRoles(): Promise<UserRole[]> {
  const assignableRoles = await getAssignableRoles();

  return assignableRoles.roles;
}

export async function saveUserPartners(user: ManagedUser): Promise<ManagedUser> {
  const partnerCodes = user.partners.map(partner => partner.partnerCode);

  return updateUserPartners(user.id, { partnerCodes });
}

export async function saveUserRoles(user: ManagedUser): Promise<ManagedUser> {
  return updateUserRoles(user.id, { roles: user.roles });
}

export async function saveUserPassword(userId: number, newPassword: string): Promise<void> {
  return updateUserPassword(userId, { newPassword });
}
